import { createStore } from 'vuex'
import auth from './modules/auth'
import cart from './modules/cart'
import wishlist from './modules/wishlist'
import notifications from './modules/notifications'

export default createStore({
  modules: { auth, cart, wishlist, notifications },
})
